import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

function CategoryIcon(props) {
  return (
    <Link to={props.link} className="category-icons">
      <div className="category-item category-list-item">
        <div className="item-icon">
          <img src={props.icon} alt=''/>
        </div>
        {props.link ? (
          <Link to={props.link} className="category-title">{props.title}</Link>
        ) : (
          <span className="category-title">{props.title}</span>
        )}
      </div>
    </Link>
  );
}

export default CategoryIcon;
